import { render, staticRenderFns } from "./CustomLinkButton.vue?vue&type=template&id=6bd1baa4&scoped=true&"
import script from "./CustomLinkButton.vue?vue&type=script&lang=js&"
export * from "./CustomLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomLinkButton.vue?vue&type=style&index=0&id=6bd1baa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1baa4",
  null
  
)

export default component.exports